import SEOHead from '../components/SEOHead';
import CertificationBadges from '../components/CertificationBadges';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import ServicesSection from '../components/ServicesSection';
import DifferentiatorsSection from '../components/DifferentiatorsSection';
import IndustriesSection from '../components/IndustriesSection';
import CTASection from '../components/CTASection';
import Footer from '../components/Footer';
import { useLanguage } from '../context/LanguageContext';
import { getSEOConfig } from '../config/seoConfig';
import { getOrganizationSchema, getLocalBusinessSchema } from '../config/structuredData';
import useScrollTracking from '../hooks/useScrollTracking';

/**
 * HomePage Component
 * 
 * Main landing page for DSI Durango website.
 * Optimized for SEO and conversion with structured data.
 */
const HomePage = () => {
  const { language } = useLanguage();
  const seoData = getSEOConfig('home', language);
  
  // Track scroll depth for analytics
  useScrollTracking('home');
  
  // Combine organization and local business schemas
  const structuredData = {
    "@context": "https://schema.org",
    "@graph": [
      getOrganizationSchema(language),
      getLocalBusinessSchema(language)
    ]
  };

  return (
    <>
      <SEOHead
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
        ogImage={seoData.ogImage}
        structuredData={structuredData}
      />
      
      <Header />
      <HeroSection />
      <ServicesSection />
      
      {/* Trust Signals - Certification Badges */}
      <section className="py-12 bg-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-center">
            <CertificationBadges badges={['iso', 'dynalab']} />
          </div>
        </div>
      </section>
      
      <DifferentiatorsSection />
      <IndustriesSection />
      <CTASection />
      <Footer />
    </>
  );
};

export default HomePage;
